import React, {useState} from "react";
import TextField from "@mui/material/TextField";
import List from "../components/List";
import "../css/docs.css";

const Docs = () => {
  const [inputText, setInputText] = useState('');

  let inputHandler = (e) => {
    var lowertext = e.target.value.toLowerCase();
    setInputText(lowertext);
  };

  return (
    <div className="container">
      <div className="main">
        <h1 className="text-light">Docs Search</h1>
        <div className="search">
          <TextField
            className="bg-light rounded"
            id="outlined-basic"
            onChange={inputHandler}
            variant="outlined"
            fullWidth
            label="Search"
          />
        </div>
      </div>
      <List input={inputText}/>
    </div>
  );
};

export default Docs;
